var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{class:{
    'button-checkbox': _vm.buttonType,
  },attrs:{"disabled":_vm.disabled,"indeterminate":_vm.isIndeterminate},on:{"change":_vm.changeCheck},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }